export default "__VITE_ASSET__qvm5FIE8__"